<router-outlet></router-outlet>


// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/app/shared/layout/containers/simple-layout/simple-layout.component.ts.SimpleLayout.html